import { ALERT_TYPE } from '~/constants';
import { notificationStore } from '~/stores/NotificationStore';
import { mergeLeft } from 'ramda';

class NotificationActions {
  private show = (notification) => {
    notificationStore.addNotification(notification);
  };

  getId = (notification) => {
    return notification.text;
  };

  showError = (notification) => {
    this.show(
      mergeLeft(notification, {
        type: ALERT_TYPE.ERROR,
        id: this.getId(notification),
      })
    );
  };

  showInfo = (notification) => {
    this.show(
      mergeLeft(notification, {
        type: ALERT_TYPE.INFO,
        id: this.getId(notification),
      })
    );
  };

  showSuccess = (notification) => {
    this.show(
      mergeLeft(notification, {
        type: ALERT_TYPE.SUCCESS,
        id: this.getId(notification),
      })
    );
  };

  showWarning = (notification) => {
    this.show(
      mergeLeft(notification, {
        type: ALERT_TYPE.WARNING,
        id: this.getId(notification),
      })
    );
  };
}

export default NotificationActions;
